import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {CommonService} from '../../services/common.service'
import { APIService } from 'src/app/api.service';
import {DataService} from '../../services/data.service'
import { MultipleSelectItemComponent } from '../multiple-select-item/multiple-select-item.component';

@Component({
  selector: 'app-product-byproducts',
  templateUrl: './product-byproducts.component.html',
  styleUrls: ['./product-byproducts.component.scss']
})
export class ProductByproductsComponent implements OnInit {

  constructor(private router: Router, public commonFun: CommonService, private apiService: APIService, 
    private dataSer: DataService, private modalService: NgbModal) {
      
      this.dataSer.byProduct.subscribe((value) => {
        let val: any = value;
        if(val.productID) {
          this.ByproductData = value;
          this.getData();
        }
      });
     }

    
   //#region "Declaration"
   @Input() ByproductData: any;
   @Input() mdlRef: any;
   prductData: any = {
      productID: 0,
      productName: 'Blue LED Light',
      byproduct:[]
    }

    modalReference: any;
    jarvisData: any = [];
    products: any = [];
    agencyData: any = [];
    isEdit: boolean = false;

  //#endregion

  //#region "Function"
  
  ngOnInit(): void {

    // let productID = this.commonFun.GetParam("PID");
    // this.prductData.productID = productID;
    this.apiService.getIDB('erp_inv', (productList: any) => {
      if (productList && productList.length > 0) {
        this.products = productList;
      }
    }); 

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    if(this.ByproductData.productID){
      this.getData();
    }
    
  }

  getData() {
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
          this.prductData.productID = this.ByproductData.productID;
          this.prductData.productName = this.ByproductData.productName;
          let selectedBOMItem = JSON.parse(this.ByproductData.Byproduct);
          this.prductData.byproduct = [];
          for (let i = 0; i < selectedBOMItem.length; i++) {
            let tmpPRD = this.products.filter((x: any) => x.ItemID == selectedBOMItem[i].IID);
            
            this.prductData.byproduct.push({
              ItemID: selectedBOMItem[i].IID,
              ReqdQty: selectedBOMItem[i].Qty,
              TypeID: 2,
              Unit: selectedBOMItem[i].Unt,
              productName: tmpPRD.length > 0 ? tmpPRD[0].ItemName : '',
              productCode: tmpPRD.length > 0 ? tmpPRD[0].ItemCode : ''
            });
          }

          // this.dataSer.dataTransfer.subscribe((value :any) => {
          //   if(value){
          //     this.prductData.productName = value.productName;
          //     // this.prductData.byproduct = JSON.parse(value.Byproduct);
          //     let selectedBOMItem = JSON.parse(value.Byproduct);
          //     for (let i = 0; i < selectedBOMItem.length; i++) {
          //       let tmpPRD = this.products.filter((x: any) => x.ItemID == selectedBOMItem[i].IID);
                
          //       this.prductData.byproduct.push({
          //         ItemID: selectedBOMItem[i].IID,
          //         ReqdQty: selectedBOMItem[i].Qty,
          //         TypeID: 2,
          //         Unit: selectedBOMItem[i].Unt,
          //         productName: tmpPRD.length > 0 ? tmpPRD[0].ItemName : '',
          //         productCode: tmpPRD.length > 0 ? tmpPRD[0].ItemCode : ''
          //       });
          //     }
          //   }
          // });
    };

    // Selected Item show in Data
    this.dataSer.items.subscribe((value :any) => {
      if (value) {
        let selecetdItems = value;
        for (let i = 0; i < selecetdItems.length; i++) {
          this.prductData.byproduct.push({
            ItemID: selecetdItems[i].ItemID,
            ReqdQty: 0,
            TypeID: 2,
            Unit: selecetdItems[i].SKU,
            productName: selecetdItems[i].ItemName,
            productCode: selecetdItems[i].ItemCode,
          });
        }
      }      
    });
    this.dataSer.tmpItems.next([]);
  }
  
  getSelectedItem(obj: any) {

  }

  openItemSelect(content: any) {
    this.modalReference = this.modalService.open(MultipleSelectItemComponent, { windowClass : "itemSelectionModalClass", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.typeID = 0; // Transaction Type
    this.modalReference.componentInstance.it = 0;
    this.modalReference.componentInstance.st = 0; // Store ID
    this.modalReference.componentInstance.rm = 1; // Show Raw-Material
    this.modalReference.componentInstance.ft = 0; // From Transaction Page if 1 Then Yes else No
    this.modalReference.componentInstance.mdlRef = this.modalReference;
  }

  closeModal() {
    this.modalReference.close();
  }

  //fn_saveBOM() - BOM Save
  fn_saveByproduct(){
    let tmpZeroQty = $.grep(this.prductData.byproduct, function(o: any){ return o.reqdQty == 0});
    if(tmpZeroQty.length > 0){
      this.apiService.successAlert("Please enter byproduct quantity more then zero.");
      return;
    }

    let finalbyproduct: any = [];
    this.prductData.byproduct.forEach(function(value:any){
      finalbyproduct.push({
        ItemID: value.ItemID,
        ReqdQty: value.ReqdQty,
        TypeID: value.TypeID,
        Unit: value.Unit
      });
      
    });

    let tempData = [{
      ItemID: this.prductData.productID,
      ChangeType: 'BYP',
      BOM: '[]',
      Byproducts: JSON.stringify(finalbyproduct),
      Stages: "",
      Units: '[]'
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'setItemDetail',
      moduleID: 5,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successBOMEntry.bind(this), this.failureBOMResp.bind(this));
  }

   //failureBOMResp - failure handler
   failureBOMResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successBOMEntry - success  get handler
  successBOMEntry(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode == 1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          }
          else{
            // this.router.navigateByUrl('/ProductDetail?PID=' + this.prductData.productID);
            if(this.mdlRef){
              this.mdlRef.close('Done');
            } else {
              this.isEdit = false;
            }
            
          }
        }
    }
  }

  goBack(){
    // window.history.back();
    this.mdlRef.close('Close');
  }

  removeByproduct(ind: number){
    this.prductData.byproduct.splice(ind, 1);
  }

  //#endregion

}
